@if (media()) {
    @if (ariaLabel()) {
        <figure class="media-wrapper" role="figure" [attr.aria-label]="ariaLabel()">
            <ng-template [ngTemplateOutlet]="ctaContainerMedia"></ng-template>
            @if (showFigureCaption()) {
                <h-media-captions [media]="media()"></h-media-captions>
            }
        </figure>
    } @else {
        <div class="media-wrapper">
            <ng-template [ngTemplateOutlet]="ctaContainerMedia"></ng-template>
        </div>
    }
}

<ng-template #ctaContainerMedia>
    @let cta = this.cta();
    @if (cta) {
        <!-- Image with CTA -->
        <h-cta-container
            [cta]="cta"
            [focusOffset]="-2"
            [ariaLabel]="linkAriaLabel()"
            [shouldSendDefaultRedirectionAnalytics]="shouldSendDefaultRedirectionAnalytics()"
            (mediaRedirectionEvent)="mediaRedirection($event)">
            <ng-template [ngTemplateOutlet]="mediaTemplate"></ng-template>
        </h-cta-container>
    } @else {
        <!-- Video (with or without CTA) or image without CTA -->
        <ng-template [ngTemplateOutlet]="mediaTemplate"></ng-template>
    }
</ng-template>

<ng-template #mediaTemplate>
    <div class="media-container">
        <h-media-picture
            [mediaPicture]="media()"
            [preload]="preload()"
            [mediaQueriesOptions]="mediaOptions()"
            [title]="title()"></h-media-picture>
        <ng-content></ng-content>
    </div>
</ng-template>
